<form [formGroup]="form" (ngSubmit)="submit()" class="form-lg">
  <div class="zwi-form-group">
    <mat-form-field [style.width]="'100%'">
      <mat-label>Email address</mat-label>
      <input autocapitalize="none" matInput formControlName="email">
      <mat-error>
        @if (form.get('email')?.errors?.required) {
          {{ formError.getErrorMessage('email', 'required') }}
        }
        @if (form.get('email')?.errors?.email) {
          {{ formError.getErrorMessage('email', 'email') }}
        }
        @if (form.get('email')?.errors?.emailTaken) {
          {{ formError.getErrorMessage('email', 'emailTaken') }}
        }
      </mat-error>
    </mat-form-field>
  </div>
  <div formGroupName="password">
    <div class="zwi-form-group">
      <mat-form-field [style.width]="'100%'">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password1" type="password" placeholder="Password">
        <mat-error>
          @if (form.get('password.password1')?.errors?.required) {
            {{ formError.getErrorMessage('password1', 'required') }}
          }
          @if (form.get('password.password1')?.errors?.minlength) {
            {{ formError.getErrorMessage('password1', 'minlength') }}
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div class="zwi-form-group">
      <mat-form-field [style.width]="'100%'">
        <mat-label>Retype password</mat-label>
        <input matInput formControlName="password2" type="password"
          placeholder="Confirm your password">
        <mat-hint>Retype password above</mat-hint>
        <mat-error>
          @if (form.get('password.password2')?.errors?.required) {
            {{ formError.getErrorMessage('password2', 'required') }}
          }
          @if (form.get('password.password2')?.errors?.passwordMatch) {
            {{ formError.getErrorMessage('password2', 'passwordMatch') }}
          }
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="layout-row layout-align-end-center">
    <ng-content></ng-content>
  </div>
</form>
